export enum DemandLetterStatus {
  PENDING = 1,
  SENT = 2,
  COMPLETED = 3
}
